// Javascript
require("@rails/ujs").start()
require("@rails/activestorage").start()
import '../src/ir/application'

// 画像読み込み設定
const images = require.context('../images', true);
const imagePath = (name) => images(name, true)

// SASS
import '../stylesheets/ir/application.scss'